<template>
  <div v-if="hasCategoryList" class="category-list-table">
    <table class="table is-striped is-hoverable is-fullwidth">
      <thead class="dark-background">
        <tr>
          <th class="has-right-border">Category</th>
          <th class="has-text-right">Total Units</th>
          <th class="has-text-right">Total Weights (Kg)</th>
          <th v-if="showUpliftColumn" class="has-text-right">Uplift (%)</th>
          <th v-if="showUpliftedUnitsColumn" class="has-text-right">
            Total Uplifted Units
          </th>
          <th v-if="showUpliftColumn" class="has-text-right">
            Total Uplifted Weights (Kg)
          </th>
          <th class="has-text-right">Total Fee ({{ data.currency }})</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="(category, catIndex) in filteredCategoryList">
          <!-- Footer categories -->
          <tr
            v-if="category.footer"
            :key="'cat-' + catIndex"
            :title="category.id ? 'ID: ' + category.id : ''"
            class="footer-category-row"
          >
            <td class="has-right-border">{{ category.main_category }}</td>
            <td class="has-text-right">
              {{ formatNumber(category.total_units) }}
            </td>
            <td class="has-text-right">
              {{ formatNumber(category.total_weight) }}
            </td>
            <td v-if="showUpliftColumn" class="has-text-right">
              {{ category.uplift_percent }}
            </td>
            <td v-if="showUpliftedUnitsColumn" class="has-text-right">
              {{ formatNumber(category.total_uplifted_units) }}
            </td>
            <td v-if="showUpliftColumn" class="has-text-right">
              {{ formatNumber(category.total_uplifted_weight) }}
            </td>
            <td class="has-text-right">
              {{
                formatNumber(
                  category.sum_final_uplifted_fee || category.total_fee
                )
              }}
            </td>
          </tr>
        </template>

        <!-- Grand Total Row -->
        <tr class="grand-total-row">
          <td class="has-text-weight-bold has-right-border">Grand Total</td>
          <td class="has-text-right has-text-weight-bold">
            {{ formatNumber(data.reported_sum_of_units) }}
          </td>
          <td class="has-text-right has-text-weight-bold">
            {{ formatNumber(data.reported_sum_of_weight) }}
          </td>
          <td v-if="showUpliftColumn" class="has-text-right"></td>
          <td
            v-if="showUpliftedUnitsColumn"
            class="has-text-right has-text-weight-bold"
          >
            {{ formatNumber(data.uplifted_reported_sum_of_units) }}
          </td>
          <td
            v-if="showUpliftColumn"
            class="has-text-right has-text-weight-bold"
          >
            {{ formatNumber(data.uplifted_reported_sum_of_weight) }}
          </td>
          <td class="has-text-right has-text-weight-bold">
            {{
              formatNumber(data.sum_final_uplifted_fee || data.final_total_fee)
            }}
            *
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: "CategoryListTable",
  props: {
    data: {
      type: Object,
      required: true
    },
    upliftApplied: {
      type: Boolean,
      default: false
    },
    upliftType: {
      type: String,
      default: null
    },
    tdWithoutPd: {
      type: String,
      default: "TD_WITHOUT_PD"
    }
  },
  computed: {
    hasCategoryList() {
      return this.filteredCategoryList && this.filteredCategoryList.length > 0;
    },
    showUpliftColumn() {
      return this.upliftApplied && this.upliftType;
    },
    showUpliftedUnitsColumn() {
      return this.upliftApplied && this.upliftType === this.tdWithoutPd;
    },
    filteredCategoryList() {
      return this.data.category_list.filter(category => {
        return [
          "Out of Scope",
          "PD without Weight",
          "TD without PD",
          "PD without Weight (Categorized)",
          "PD without Weight (Uncategorized)"
        ].includes(category.main_category);
      });
    }
  },
  methods: {
    formatNumber(value) {
      if (value === null || value === undefined || value === "") return "0";
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  }
};
</script>

<style scoped>
.category-list-table .table {
  border: 1px solid #dbdbdb;
  border-radius: 4px;
}

.category-list-table .table thead th {
  background-color: #e0e0e0;
  font-weight: 600;
  border-bottom: 2px solid #dbdbdb;
  padding: 0.75rem;
}

.footer-category-row {
  background-color: #f9f9f9;
}

.footer-category-row td {
  font-weight: 500;
}

.grand-total-row {
  border-top: 2px solid #dbdbdb;
}

.grand-total-row td {
  padding: 0.75rem;
  font-size: 1rem;
}

.has-text-right {
  border-right: 1px solid #dbdbdb;
}

.has-right-border {
  border-right: 1px solid #dbdbdb;
}

.pl-5 {
  padding-left: 2rem !important;
}
</style>
